<div class="modal-header">
  <h3 class="modal-title">
    Tax Sensitive Acct
    <i (click)="cancel()" class="fa fa-times pull-right pointer"></i>
    <i
      class="fa pull-right pointer"
      [ngClass]="{ 'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise }"
      style="margin-right: 10px"
      (click)="minimise = !minimise"
    ></i>
  </h3>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div class="divShadow">
    <div class="row">
      <div class="col-md-1 profile"></div>
      <div class="col-md-12">
        <div class="table-wrap">
          <table class="gt-client table table-bordered table-striped table-condensed custom-table">
            <thead>
              <tr>
                <th class="text-align">Action</th>
                <th>
                  <i class="fa pr-5 pointer" (click)="orderByField='TRIGGER_ACCT'; sortBy('1', sort_key['1'])"></i>
                  TRIGGER ACCT
                </th>
                <th>
                  <i class="fa pr-5 pointer" (click)="orderByField='TEMPLATE'; sortBy('2', sort_key['2'])"></i>
                  TEMPLATE
                </th>
                <th>
                  <i class="fa pr-5 pointer" (click)="orderByField='USER_DESC'; sortBy('3', sort_key['3'])"></i>
                  USER_DESC
                </th>
                <th>
                  <i class="fa pr-5 pointer" (click)="orderByField='SCHDM_TYPE'; sortBy('4', sort_key['4'])"></i>
                  SCHDM_TYPE
                </th>
                <th>
                  <i class="fa pr-5 pointer" (click)="orderByField='POSTING_TAC'; sortBy('5', sort_key['5'])"></i>
                  POSTING TAC
                </th>
                <th>
                  <i class="fa pr-5 pointer" (click)="orderByField='POSTING_ACCT'; sortBy('6', sort_key['6'])"></i>
                  POSTING ACCT
                </th>
                <th>
                  <i class="fa pr-5 pointer" (click)="orderByField='TAX_STREAM_ACCT'; sortBy('7', sort_key['7'])"></i>
                  TAX STREAM ACCT
                </th>
                <th>
                  <i class="fa pr-5 pointer" (click)="orderByField='METHOD_OF_CALC'; sortBy('8', sort_key['8'])"></i>
                  METHOD_OF CALC
                </th>
                <th>
                  <i class="fa pr-5 pointer" (click)="orderByField='MULTIPLIER'; sortBy('9', sort_key['9'])"></i>
                  MULTIPLIER
                </th>
              </tr>
            </thead>
            <tbody>
              @for (taxSensitive of sortedRows; track $index) {
<tr>
                <td class="text-align">
                  <i class="fa fa-edit pointer pr-5" (click)="formEdit(taxSensitive)"></i>
                  <i class="fa fa-trash pointer" (click)="formDelete(taxSensitive)"></i>
                </td>
                <td>{{ taxSensitive.TRIGGER_ACCT }}</td>
                <td>
                  @if (taxSensitive.isEditable) {
<select
                   
                    class="drop-down-list"
                    [ngModel]="taxSensitive.dropdowndata"
                    (ngModelChange)="taxSensitive.dropdowndata = $event; changeTemplate(taxSensitive)"
                  >
                    @for (tempacct of templocalaccount; track $index) {
<option [value]="tempacct">{{ tempacct }}</option>
}
                  </select>
}
                  @if (!taxSensitive.isEditable) {
<span>{{ taxSensitive.SCHDM_TEMPLATE_TABLE }}</span>
}
                </td>
                <td>
                  @if (taxSensitive.isEditable) {
<span>
                    <input type="text" [ngModel]="taxSensitive.USER_DESC" (ngModelChange)="taxSensitive.USER_DESC = $event" />
                  </span>
}
                  @if (!taxSensitive.isEditable) {
<span>{{ taxSensitive.USER_DESC }}</span>
}
                </td>
                <td>{{ taxSensitive.SCHDM_TYPE }}</td>
                <td>{{ taxSensitive.POSTING_TAC }}</td>
                <td>{{ taxSensitive.POSTING_ACCT }}</td>
                <td>{{ taxSensitive.TAX_STREAM_ACCT }}</td>
                <td>{{ taxSensitive.METHOD_OF_CALC }}</td>
                <td>{{ taxSensitive.MULTIPLIER }}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="save-button" type="button" (click)="save()">
        @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
      </button>
      <button class="reset-button" type="button" (click)="resetLookup()">Reset</button>
      <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
    </div>
  </div>
}
</div>
